"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHAT_MODELS = exports.LLMVendor = exports.getInternalAIModel = exports.LLM_RAG = exports.LLM_FORM_FILL = exports.LLM_DEFAULT = exports.LLM_TMS = exports.LLM_NOTES_COMPONENT_SCANNING = exports.LLM_SANITY_CHECK_BANNING_ORDERS = exports.LLM_PROCESS_HR_ALERT_CROSS_CHECK = exports.LLM_PROCESS_HR_NOTE_ANALYSIS = exports.LLM_PROCESS_BOX = exports.LLMBaseModelThreads = exports.LLMBaseModelT = void 0;
const t = __importStar(require("@sinclair/typebox"));
const tBoxValue = __importStar(require("@sinclair/typebox/value"));
exports.LLMBaseModelT = t.Union([
    t.Literal('gpt-main'),
    t.Literal('gpt-mini'),
    t.Literal('gemini-pro'),
    t.Literal('gemini-flash'),
]);
exports.LLMBaseModelThreads = {
    'gpt-mini': 50,
    'gpt-main': 16,
    'gemini-pro': 20,
    'gemini-flash': 50,
};
exports.LLM_PROCESS_BOX = {
    baseModel: 'gemini-flash',
    reasoning: 'high',
};
exports.LLM_PROCESS_HR_NOTE_ANALYSIS = {
    baseModel: 'gemini-flash',
    reasoning: 'medium',
};
exports.LLM_PROCESS_HR_ALERT_CROSS_CHECK = {
    baseModel: 'gpt-mini',
    reasoning: 'medium',
};
exports.LLM_SANITY_CHECK_BANNING_ORDERS = {
    baseModel: 'gpt-mini',
    reasoning: 'medium',
};
exports.LLM_NOTES_COMPONENT_SCANNING = {
    baseModel: 'gemini-flash',
    reasoning: 'medium',
};
exports.LLM_TMS = {
    summarise: { baseModel: 'gpt-main', reasoning: 'low' },
    splitEmailBase: { baseModel: 'gemini-flash', reasoning: 'low' },
    splitEmailRetry: { baseModel: 'gpt-main', reasoning: 'low' },
    splitEmailCompare: { baseModel: 'gemini-flash', reasoning: 'low' },
    buddy: { baseModel: 'gpt-main', reasoning: 'low' },
};
exports.LLM_DEFAULT = 'gemini-flash';
exports.LLM_FORM_FILL = 'gemini-flash';
exports.LLM_RAG = {
    rephrase: { baseModel: 'gpt-main', reasoning: 'low' },
    fast: { baseModel: 'gemini-flash', reasoning: 'low' },
    good: { baseModel: 'gemini-flash', reasoning: 'low' },
    deep: { baseModel: 'gemini-flash', reasoning: 'medium' },
};
const getInternalAIModel = (base) => {
    const model = base ?? exports.LLM_DEFAULT;
    if (!tBoxValue.Check(exports.LLMBaseModelT, model)) {
        throw new Error(`Invalid model: ${String(model)}`);
    }
    let key = 'gpt-5.4-mini-2026-03-17';
    if (model === 'gpt-main') {
        key = 'gpt-5.5-2026-04-23';
    }
    if (model === 'gpt-mini') {
        key = 'gpt-5.4-mini-2026-03-17';
    }
    if (model === 'gemini-pro') {
        key = 'gemini-3.1-pro-preview';
    }
    if (model === 'gemini-flash') {
        key = 'gemini-3.5-flash';
    }
    return exports.CHAT_MODELS[key];
};
exports.getInternalAIModel = getInternalAIModel;
var LLMVendor;
(function (LLMVendor) {
    LLMVendor["OpenAI"] = "openai";
    LLMVendor["Anthropic"] = "anthropic";
    LLMVendor["Gemini"] = "google";
})(LLMVendor || (exports.LLMVendor = LLMVendor = {}));
exports.CHAT_MODELS = {
    'gpt-5.5-2026-04-23': {
        name: 'gpt-5.5-2026-04-23',
        maxTokens: 200_000,
        costRead: 5,
        costWrite: 30,
        vendor: LLMVendor.OpenAI,
        reasoning: true,
    },
    'gpt-5.4-mini-2026-03-17': {
        name: 'gpt-5.4-mini-2026-03-17',
        maxTokens: 200_000,
        costRead: 0.75,
        costWrite: 4.5,
        vendor: LLMVendor.OpenAI,
        reasoning: true,
    },
    'gemini-3.1-pro-preview': {
        name: 'gemini-3.1-pro-preview',
        maxTokens: 200_000,
        costRead: 2,
        costWrite: 12,
        vendor: LLMVendor.Gemini,
        reasoning: true,
    },
    'gemini-3.5-flash': {
        name: 'gemini-3.5-flash',
        maxTokens: 200_000,
        costRead: 1.5,
        costWrite: 9.0,
        vendor: LLMVendor.Gemini,
        reasoning: true,
    },
};
exports.CHAT_MODELS;
//# sourceMappingURL=types-llm.js.map